const cardElementStyle = {
  base: {
    color: '#32325d',
    lineHeight: '24px',
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: '#aab7c4'
    }
  },
  invalid: {
    color: '#fa755a',
    iconColor: '#fa755a'
  }
};

class StripeField {

  constructor($timeout, $element, configuration, eventsService) {
    this.$timeout = $timeout;
    this.$element = $element;
    this.configuration = configuration;
    this.eventsService = eventsService;
    this.stripe = Stripe(this.configuration.settings.stripePublishableKey);
  }

  $onInit() {
    this.cardElement = this.stripe.elements().create('card', {
      style: cardElementStyle
    });

    //Timeout with no duration allows the DOM to render before attempting to mount the stripe element.
    this.$timeout(() => this.cardElement.mount(this.getCardContainer()));
  }

  getCardContainer() {
    return this.$element[ 0 ].getElementsByTagName('div')[ 0 ];
  }

  submit() {
    const stripeRequest = this.createStripeRequest();
    this.onTokenReceived({promise: stripeRequest});
    return stripeRequest;
  }

  createStripeRequest() {
    return new Promise((resolve, reject) => {
      this.stripe.createToken(this.cardElement).then(result => {
        if (result.error) {
          reject(result.error);
        } else {
          resolve(result.token);
        }
      });
    });
  }
}

export default {
  name: 'stripeField',
  obj: {
    controller: StripeField,
    controllerAs: '$ctrl',
    bindings: {
      onTokenReceived: '&'
    },
    template: `
      <label>Credit or debit card
        <div id="card-element"></div>
      </label>
      <action-button action="$ctrl.submit()"
                    initial-text="'Submit'"
                    risk="safe"
                    type="bordered"></action-button>
    `
  }
}